export const
    headerStyle= {
        backgroundColor: '#A14EFF',
        margin: '5px',
}
export const rowStyle ={
    ...headerStyle, opacity: '0.75'
}
export const buttonStyle ={
    backgroundColor: '#edece1', margin: '2px'
}